import type { GridCandidate } from "./types";

const PREFIXED_GRID =
  /\b(?:G\s*R|GRID)\s*[:#-]?\s*((?:\d[\s,./-]*){4,10})(?![\s,./-]*\d)/gi;

function candidateFromDigits(digits: string): GridCandidate | null {
  if (digits.length % 2 !== 0) return null;
  const half = digits.length / 2;
  const easting = digits.slice(0, half);
  const northing = digits.slice(half);
  return {
    easting,
    id: `grid-${easting}-${northing}`,
    label: `GR ${easting} ${northing}`,
    northing,
    value: `${easting} ${northing}`,
  };
}

export function extractGridCandidates(text: string): readonly GridCandidate[] {
  const candidates = new Map<string, GridCandidate>();
  for (const match of text.matchAll(PREFIXED_GRID)) {
    const captured = match[1];
    /* v8 ignore next -- the capture group is mandatory in PREFIXED_GRID */
    if (captured === undefined) continue;
    const digits = captured.replace(/\D/g, "");
    const candidate = candidateFromDigits(digits);
    if (candidate !== null) candidates.set(candidate.id, candidate);
  }
  return [...candidates.values()];
}

export function formatRegisteredGridValue(
  value: string,
  isKnownGrid: boolean,
): string {
  return isKnownGrid ? value : `GR ${value}`;
}
